module.exports = __webpack_public_path__ + "static/media/giftCard.7eaf2c83.png";